module.exports = __webpack_public_path__ + "6986faf4c39b2a1ae63b4612b4d1e0dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/tjx_companies_2023_chart.png
// module id = 1752
// module chunks = 0